import { render } from "./MessageEditor.vue?vue&type=template&id=6f1c2e91&ts=true"
import script from "./MessageEditor.ts?vue&type=script&lang=ts"
export * from "./MessageEditor.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__